import { acceptOnlyValidOptionByLabel } from '../../field-viewer/shared-normalizers';
export const quizRadioGroupViewer = {
    normalizeLoadedValue: acceptOnlyValidOptionByLabel
};

//# sourceMappingURL=definition-viewer.js.map